import { render, staticRenderFns } from "./text-link.vue?vue&type=template&id=1edfe7e0&scoped=true&"
import script from "./text-link.vue?vue&type=script&lang=ts&"
export * from "./text-link.vue?vue&type=script&lang=ts&"
import style0 from "./text-link.vue?vue&type=style&index=0&id=1edfe7e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edfe7e0",
  null
  
)

export default component.exports